import * as React from 'react';
import type { SVGProps } from 'react';

const SvgDe = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 1200" {...props}>
    <path
      fillRule="evenodd"
      d="M468.9 259.93a5.7 5.7 0 0 0-3.82 1.254l-85.301 68.238a5.72 5.72 0 0 0-1.828 6.344l80.086 230.04 88.633 363.09a5.72 5.72 0 0 0 5.257 4.351l124.53 6.82a5.8 5.8 0 0 0 1.598-.132l139.88-32.414a5.724 5.724 0 0 0 4.25-6.996l-44.352-172.29a5.726 5.726 0 0 0-7.426-3.973l-31.512 11.027-79.543-50.332-36.887-107.28a5.7 5.7 0 0 0-.515-1.09l-49.461-81.89a5.7 5.7 0 0 0-2.14-2.052l-51.497-28.234-45.652-78.258 28.16-82.836a5.66 5.66 0 0 0 .266-2.539l-3.422-27.289a5.73 5.73 0 0 0-3.75-4.68l-23.883-8.53a5.8 5.8 0 0 0-1.668-.34z"
    />
  </svg>
);
export default SvgDe;
